import CommonBarContainer from 'views/molecules/commonbar/CommonBarContainer';

export default CommonBarContainer;
